import { render, staticRenderFns } from "./BusinessStartupPageCustomerOrderDetails.vue?vue&type=template&id=5a124e33&"
import script from "./BusinessStartupPageCustomerOrderDetails.vue?vue&type=script&lang=ts&"
export * from "./BusinessStartupPageCustomerOrderDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a124e33')) {
      api.createRecord('5a124e33', component.options)
    } else {
      api.reload('5a124e33', component.options)
    }
    module.hot.accept("./BusinessStartupPageCustomerOrderDetails.vue?vue&type=template&id=5a124e33&", function () {
      api.rerender('5a124e33', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/business-startups/customer-orders/BusinessStartupPageCustomerOrderDetails.vue"
export default component.exports